interface AccessDeniedPageProps {
  onReturn: () => void;
  title?: string;
  message?: string;
}

export function AccessDeniedPage({ onReturn, title, message }: AccessDeniedPageProps) {
  return (
    <section className="access-denied">
      <span className="access-denied__icon">!</span>
      <span className="eyebrow">Acceso restringido</span>
      <h1>{title || 'No tienes permiso para ver esta sección'}</h1>
      <p>{message || 'Tu rol no permite esta acción. Si necesitas acceso, pídele al Dueño o a un administrador que revise tu rol.'}</p>
      <button className="button button--primary" onClick={onReturn} type="button">Volver al inicio</button>
    </section>
  );
}
